module.exports = "table, tr, td {\n  border: none !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/application-confirmation/application-confirmation.component.css
// module id = ./src/app/shared/components/application-confirmation/application-confirmation.component.css
// module chunks = main